import ResponseStatus from "./api";

/**
 * Billing cycle renewal feature constants
 *
 * Billing cycle renewal occurs when order has:
 * - status = "CANCELED_BY_GATEWAY"
 * - subscriptionBillingCycle.billingCycle > 1
 */

/** Feature flag - set to false to disable feature */
export const BILLING_CYCLE_RENEWAL_ENABLED = true;

/** Order statuses that indicate cancelled by gateway */
export const BILLING_CYCLE_RENEWAL_STATUSES: string[] = [
  ResponseStatus.CANCELLED_BY_GATEWAY,
  ResponseStatus.CANCELLED_BY_GATEWAY_DEFINITIVE,
];

/** Minimum billing cycle to trigger renewal */
export const BILLING_CYCLE_RENEWAL_MIN_CYCLE = 1;

/** Debug label for logging */
export const BILLING_CYCLE_RENEWAL_DEBUG_LABEL = "BillingCycleRenewal";

export const BillingCycleRenewalConstants = {
  ENABLED: BILLING_CYCLE_RENEWAL_ENABLED,
  STATUSES: BILLING_CYCLE_RENEWAL_STATUSES,
  MIN_CYCLE: BILLING_CYCLE_RENEWAL_MIN_CYCLE,
  DEBUG_LABEL: BILLING_CYCLE_RENEWAL_DEBUG_LABEL,
} as const;

export default BillingCycleRenewalConstants;
